import { IRIS_S1_PROMOTIONALBANNERDATA_GET_REQUEST } from '../actionTypes/PromotionalBannerActionTypes';

const getIrisS1PromoBannerAction = (urlParams) => ({
    type: IRIS_S1_PROMOTIONALBANNERDATA_GET_REQUEST,
    urlParams,
});

export default getIrisS1PromoBannerAction;
